/* eslint-disable @typescript-eslint/no-explicit-any */
// chat.ts
import { toast } from 'react-toastify';
import { apiAiClient } from './kyAi';
import { apiClient } from './axios';
import { IPagination } from '../interface/panigation';

export interface IFile {
  description: string;
  type: string;
  url: string;
}

export interface IListChat {
  id: string;
  title: string;
  aiModelId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface IMessageInChat {
  id: string;
  content: {
    text: string;
    files?: IFile[];
  };
  conversationId: string;
  senderRole: string;
  createdAt: string;
  updatedAt: string;
}

export interface IAiModel {
  aiModelProvider: {
    id: string;
    name: string;
    image: string;
    isActive: boolean;
  };
  id: string;
  name: string;
  code: string;
  type: string;
  version: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

//send message

export interface IMessageRequest {
  question: {
    text: string;
    img_urls?: string[];
  };
  llm_name: string;
  model: string;
  conversation_id: string;
  access_token_user: string;
}

// send message BE
export interface IMessageRequestBE {
  content: {
    text: string;
    files?: {
      url: string;
      type: string;
      description: string;
    }[];
  };
}

export interface ICreateConversation extends IMessageRequestBE {
  aiModelId: string;
}

export interface IGenerateTitle {
  conversation_id: string;
  access_token_user: string;
  llm_name: string;
  model: string;
  history_chat: string[];
  aiModelId?: string;
  userId?: string;
}
///api/v1/chat/generate-title"
export const generateTitle = async (data: IGenerateTitle): Promise<string> => {
  const response = await apiAiClient.post<{ title: string }>(`api/v1/chat/generate-title`, data);
  return response.title;
};

export const sendMessage = async (
  message: IMessageRequest, 
  onChunk: (chunk: string) => void
): Promise<void> => {
  try {
    await apiAiClient.postStream(
      'api/v1/chat/completions', 
      message,
      { 
        onChunk: async (chunk: any) => {
          onChunk(chunk);
          
        }
      }
    );
  } catch (error) {
    toast.error('Lỗi khi gửi tin nhắn', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    console.error('Error in chat stream:', error);
    throw error;
  }
};

//get list chat
export const getListChat = async (offset: number, limit: number, search: string): Promise<IPagination<IListChat>> => {
  const params = {
    offset: offset,
    limit: limit,
    sort: '-createdAt',
    search: ''
  };
  if (search) {
    params.search = search;
  }
  const response = await apiClient.get<IPagination<IListChat>>(`conversations`, { params });
  return response.data as IPagination<IListChat>;
};

//get message in chat
export const getMessageInChat = async (conversationId: string | null, params: { offset: number, limit: number }): Promise<IPagination<IMessageInChat>> => {
  if (!conversationId) {
    return {
      items: [],
      total: 0,
      totalPages: 0,
      itemsPerPage: 0,
    };
  }
  const paramChat = {
    offset: params.offset,
    limit: params.limit,
  };
  const response = await apiClient.get<IPagination<IMessageInChat>>(`conversations/${conversationId}/messages`, { params: paramChat });
  return response.data as IPagination<IMessageInChat>;
};

//ai-models
export const getAiModels = async (): Promise<IAiModel[]> => {
  const response = await apiClient.get<IAiModel[]>(`ai-models`);
  return response.data as IAiModel[];
};

///conversations/$conversationId/messages
export const sendMessageInChat = async (conversationId: string, message: IMessageRequestBE): Promise<IMessageInChat> => {
  const response = await apiClient.post<IMessageInChat>(`conversations/${conversationId}/messages`, message);
  return response.data as IMessageInChat;
};

//create conversation
export const createConversation = async (payload: ICreateConversation): Promise<IListChat> => {
  const response = await apiClient.post<IListChat>(`conversations/new`, payload);
  return response.data as IListChat;
};

//assets/asset-presign-url?fileName=$fileName&fileType=$fileType&fileExt=$fileEx
export const getAssetPresignUrl = async (fileName: string, fileType: string, fileExt: string): Promise<{ presignUrl: string, url: string }> => {
  const response = await apiClient.get<{ presignUrl: string, url: string }>(`assets/asset-presign-url?fileName=${fileName}&fileType=${fileType}&fileExt=${fileExt}`);
  return response.data as { presignUrl: string, url: string };
};

export interface IStopConversation {
  conversation_id: string;
  access_token_user: string;
}
//stop conversation
export const stopConversation = async (data: IStopConversation): Promise<void> => {
  await apiAiClient.post(`api/v1/chat/stop-streaming`, data);
};

  